<template>
    <div>
        <sweet-modal blocking title="Purchase Request" ref="purchaseProjectTaskRequest" class="modal" v-on:close="closePurchaseProjectTaskRequest">
            <el-form :model="form" size="mini" label-width="115px" ref="form" status-icon :rules="rules"  class="demo-ruleForm">
                <!--<div style="display:flex; justify-content: flex-start;">-->
                    <!--<h2>Purchase Request</h2>-->
                <!--</div>-->
                <!--{{selectedRow}}-->
                <!--{{form}}-->
                <el-row class="header-row" :span="24" :gutter="20">
                    <el-col :span="12">
                        <el-form-item prop="projectId" label="Project">
                            <el-select disabled v-model="selectedProjectId" style="width:100%" no-data-text="no date" placeholder="Project">
                                <el-option
                                        v-for="item in projectList"
                                        :key="item.projectId"
                                        :label="item.name"
                                        :value="item.projectId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="selectedRow.type !== 'project'" :span="12">
                        <el-form-item prop="taskId" label="Task">
                            <el-select disabled v-model="selectedTaskId" style="width:100%" no-data-text="no date" placeholder="Task">
                                <el-option
                                        v-for="item in projectTaskList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :span="24" :gutter="20">
                    <el-col :span="12">
                        <el-form-item prop="vendorId" label="Vendor">
                            <el-select style="width:100%" no-data-text="no date" v-model="form.vendorId" placeholder="Task Type">
                                <el-option
                                        v-for="item in vendorList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                        @click.native="handleSelectVendor(item)">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item prop="date" label="Order Date">
                            <el-date-picker
                                    v-model="form.date"
                                    format="d MMM yy"
                                    value-format="timestamp"
                                    type="date"
                                    placeholder="Pick a day">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :span="24" :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="Current Credit">
                            {{formatPrice(form.vendorCredit)}}
                        </el-form-item>
                        <el-form-item label="Vendor Currency">
                            {{form.vendorCurrency}}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="Exchange Rate" prop="exchageRate">
                            <el-input type="number" placeholder="Exchange Rate" v-model="form.exchageRate"></el-input>
                        </el-form-item>
                        <el-form-item>
                            {{form.exchageRate}} USD = 1 {{form.vendorCurrency}}
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :span="24" :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="Reference" prop="reference">
                            <el-input placeholder="Reference" v-model="form.reference"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="Deliver to:" prop="deliverTo">
                            <el-input placeholder="Deliver to" v-model="form.deliverTo"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :span="24">
                    <el-form-item label="Description" prop="description">
                        <el-input type="textarea" v-model="form.description"></el-input>
                    </el-form-item>
                </el-row>
                <el-row :span="24">
                    <el-form-item  label="Select Items" prop="itemsId">
                        <el-select :disabled="disabledInputs" style="width:100%" v-model="form.itemsId" multiple filterable @remove-tag="removeTag" placeholder="Items">
                            <el-option
                                    v-for="item in selectedVendor.items"
                                    :key="item.id"
                                    :label="item.number + '/' +  item.name"
                                    :value="item.id"
                                    @click.native="setItemToRequest(item)">
                                <span style="float: left">No. {{ item.number }}</span>
                                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.name }}</span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
                <!--{{form.ifTax}}-->
                <el-row :span="24">
                    <el-form-item prop="ifTax">
                        <el-radio-group :disabled="disabledInputs" v-model="form.ifTax" style="display:flex;">
                            <el-radio label="Tax Exclusive"></el-radio>
                            <el-radio label="Tax Inclusive"></el-radio>
                        </el-radio-group>
                    <el-form-item prop="isWth">
                        <el-checkbox :disabled="disabledInputs" @change="countModalFull()" v-model="form.isWth" label="Apply WHTax"></el-checkbox>
                    </el-form-item>
                    </el-form-item>
                </el-row>
                <!--TABLE START -->
                Items
                    <el-table
                            size="mini"
                            border
                            :data="form.items"
                            style="width: 100%"
                            @cell-click="cellClick">
                        <el-table-column
                                label="No."
                                width="80">
                            <template slot-scope="scope">
                                {{scope.row.code}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="Name"
                                width="100">
                            <template slot-scope="scope">
                                {{scope.row.name}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="Unit Price">
                            <template slot-scope="scope">
                                <el-form-item label-width="0"
                                              :prop="'items.' + scope.$index + '.amount'"
                                              :rules="{
                                          required: true, message: 'Field is required', trigger: 'blur'
                                          }">
                                    <el-input :disabled="disabledInputs" @mouseleave.native="countModalFull()" @change="countModalFull()" type="number" v-model="scope.row.amount" size="mini"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="Qty"
                                width="80">
                            <template slot-scope="scope">
                                <el-form-item label-width="0"
                                              :prop="'items.' + scope.$index + '.qty'"
                                              :rules="[
                                              { required: true, message: 'Field is required', trigger: 'blur' },
                                              { validator: checkNum, trigger: 'blur' }]">
                                    <el-input :disabled="disabledInputs" v-model="scope.row.qty" @mouseleave.native="countModalFull()" @change="countModalFull()" type="number"  size="mini"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="VAT exclusive">
                            <template slot-scope="scope">
                                {{formatPrice(scope.row.vatExclusive = countVatExclusive(Number(scope.row.amount), Number(scope.row.qty), scope.row.tax, form.ifTax))}}
                                <!--{{formatPrice(vatExclusive)}}-->
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="Tax">
                            <template slot-scope="scope">
                                <el-form-item label-width="0"
                                              :prop="'items.' + scope.$index + '.taxId'"
                                              :rules="{
                                              required: true, message: 'Field is required', trigger: 'blur'
                                              }">
                                    <el-select :disabled="disabledInputs" type="number" v-model="scope.row.taxId" size="mini" placeholder="Tax">
                                        <el-option
                                                v-for="item in taxList"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id"
                                                @click.native="scope.row.tax = item">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="Unit"
                                width="80">
                            <template slot-scope="scope">
                                {{scope.row.unit.name}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="WHTax"
                                width="100px">
                            <template slot-scope="scope">
                                <div v-if="form.isWth">
                                    {{scope.row.itemWhTaxName}}
                                </div>
                                <div v-else>
                                    N/A
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="Required Delivery date">
                            <template slot-scope="scope">
                                <el-form-item label-width="0px"
                                              :prop="'items.' + scope.$index + '.date'"
                                              :rules="{
                                          required: true, message: 'Field is required', trigger: 'blur'
                                          }">
                                    <el-date-picker
                                            :disabled="disabledInputs"
                                            v-model="scope.row.date"
                                            format="d MMM yy"
                                            value-format="timestamp"
                                            type="date"
                                            placeholder="Pick a day">
                                    </el-date-picker>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="Total">
                            <template slot-scope="scope">
                                {{formatPrice(scope.row.total = countTotalAmount(scope.row.amount, scope.row.qty, scope.row.tax, form.ifTax))}}
                            </template>
                        </el-table-column>
                    </el-table>
                <!--TABLE END -->

                <el-row :span="24" style="display:flex; justify-content: flex-end">
                    <el-col :span="12">
                        <el-form-item style="margin-bottom:0; margin-top:20px;">
                            <el-checkbox :disabled="disabledInputs" v-model="form.allowPartialDeliveries" label="Allow Partial Deliveries"></el-checkbox>
                        </el-form-item>
                        <el-form-item style="margin-bottom:0;">
                            <el-checkbox :disabled="disabledInputs" v-model="form.sendInventoryWithBill" label="Send Inventory with Bill"></el-checkbox>
                        </el-form-item>
                        <el-form-item style="margin-bottom:0;">
                            <el-checkbox :disabled="disabledInputs" v-model="form.sendInventoryWithoutBill" label="Send Inventory without Bill"></el-checkbox>
                        </el-form-item>
                        <el-form-item style="margin-bottom:0;">
                        Internal
                        </el-form-item>
                        <el-form-item style="margin-bottom:0;">
                            <el-checkbox :disabled="disabledInputs" v-model="form.receiveReportRequired" label="Receive Report Required"></el-checkbox>
                        </el-form-item>
                        <el-form-item style="margin-bottom:0;">
                            <el-checkbox :disabled="disabledInputs" v-model="form.inspectionReportRequired" label="Inspection Report Required"></el-checkbox>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                    <div class="bill">
                        <h4 v-if="form.ifTax === 'Tax Exclusive'"><span>Subtotal</span><span> {{formatPrice(form.subTotal = countSubtotal(form.items))}} </span></h4>
                        <h4 v-if="form.ifTax === 'Tax Exclusive'"><span>+ Tax of</span><span>{{formatPrice(form.taxOf = countTaxOf(form.items))}}</span></h4>
                        <h4 v-if="form.ifTax === 'Tax Inclusive'"><span>Includes Tax of</span><span>{{ formatPrice(form.includesTaxOf = countIncludesTaxOf(form.items))}} </span></h4>
                        <h4><span>Total Amount</span><span> {{formatPrice(form.totalAmount = countSumTotalAmount(form.items))}} </span> </h4>
                        <h4 v-if="form.isWth"><span>WHTax Amount</span><span>{{formatPrice(form.whtTaxAmount = countWhtTaxAmount(form.items)) }}</span></h4>
                        <el-divider></el-divider>
                        <div class="payment-to-vendor">
                            <h3><span>Payment to Vendor</span><span>{{formatPrice(form.paymentToVendor = countPaymentToVendor(form.totalAmount, form.whtTaxAmount, form.isWth))}}</span></h3>
                        </div>
                    </div>
                    </el-col>
                </el-row>

                <el-form-item style="display: flex; justify-content: flex-end; margin-top:20px;">
                    <el-button @click="purchaseSubmit('form')" class="modal__btn" type="primary" plain size="medium">Add Request</el-button>
                </el-form-item>
            </el-form>
        </sweet-modal>
    </div>
</template>

<script>
  import MessageBox from '@/components/Projects/accountTHINK/purchase/taskWithoutVendorMessageBox/main.js';
  import axios from 'axios'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue';


  export default {
    name: "purchaseProjectTaskRequestModal",
    components:{
      SweetModal,
      MessageBox
    },
    computed: {
      companyLayout() {
        return this.$store.getters.getCompanyLayout
      }
    },
    props: ['selectedRow', 'activeProject'],
    data() {
      return{
        projectList: [],
        selectedProjectId: null,
        projectTaskList: [],
        selectedTaskId: null,
        disabledInputs: true,
        vendorList:[],
        itemsList:[],
        taxList: [],
        selectedVendor: {},
        form:{
          vendorId: '',
          date: null,
          vendorCurrency: "GBP",
          vendorCredit: '0',
          exchageRate: null,
          reference: null,
          deliverTo: null,
          description: null,
          itemsId:[],
          ifTax: 'Tax Exclusive',
          isWth: false,
          items:[],
          //bill
          subTotal: '0',
          taxOf: '0',
          totalAmount:'0',
          includesTaxOf: '0',
          whtTaxAmount: '0',
          paymentToVendor: '0',
          //checkboxes
          allowPartialDeliveries: false,
          sendInventoryWithBill: false,
          sendInventoryWithoutBill: false,
          receiveReportRequired:false,
          inspectionReportRequired:false
        },
        rules:{
          vendorId: [
            { required: true, message: 'Please input Vendor name', trigger: 'blur' }
            ],
          reference: [
            { required: true, message: 'Please pick a reference', trigger: 'blur' }
          ],
          itemsId:[
            { required: true, message: 'Please pick a reference', trigger: 'blur' }
          ]
        },
      }
    },
    methods:{
      // open modal from project/eng/bu
      async openModal(){
        let loader = this.$loading.show();
        // manage selectedRow
        if(this.selectedRow.type === 'project'){
          this.selectedProjectId = this.selectedRow.projectId;
          this.projectList = [this.selectedRow]
        }else{
          this.selectedTaskId = this.selectedRow.id;
          this.projectTaskList = [this.selectedRow];
          this.selectedProjectId = this.activeProject.projectId;
          this.projectList = [this.activeProject]
        }
        // check what selected task or project
        const item = this.selectedRow.type === 'project' ? 'projectId' : 'projectTaskId';
        const id = this.selectedRow.type === 'project' ? this.selectedRow.projectId : this.selectedRow.id;
        const text = this.selectedRow.type === 'project' ? 'Project' : 'Task';

        //get vendor list
        const vendorList = await this.getDirectory(this.$route.query.companyId, item, id);
        const projectVendorList = await this.getDirectoryProject(this.selectedRow);

        //if no vendors show warning and return
        if(!vendorList.length && !projectVendorList.length){
          loader.hide();
          return this.$alert(`${text} without vendor!`, 'Warning', {
          confirmButtonText: 'OK',
          type: 'info',
          callback: action => {

          }
        });
        }else if (!vendorList.length && projectVendorList.length && this.companyLayout.access.manageCompanyVendors) {
          loader.hide();
          MessageBox.confirm('Add vendor?', `${text} without vendor!`, {
            distinguishCancelAndClose: true,
            confirmButtonText: 'Ok',
            cancelButtonText: 'Cancel',
            list: projectVendorList,
            row: this.selectedRow,
            companyId: this.$route.query.companyId
          })
            .then((data) => {
              this.notification("Success", "Vendor added", "success");
              this.getDirectory(this.$route.query.companyId, item, id);
              this.$refs.purchaseProjectTaskRequest.open();
            })
            .catch(action => {
              if (action === 'cancel'){
                // alert('cancel btn')
              }else {
                // alert('cancel')
              }
            })
        } else if (!vendorList.length && projectVendorList.length && !this.companyLayout.access.manageCompanyVendors) {
          loader.hide();
          return this.$alert(`${text} without vendor!`, 'Warning', {
            confirmButtonText: 'OK',
            type: 'info',
            callback: action => {

            }
          });
        }else{
          this.$refs.purchaseProjectTaskRequest.open();
          loader.hide()
        }
      },
      // // open modal purchases
      // async openModalFromPurchase(state){
      //   this.$refs.purchaseProjectTaskRequest.open()
      // },
      getDirectory(companyId, item, id){
      return new Promise((resolve, reject) =>{
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .get(`/api/v1/purchaseRequest/directory?companyId=${this.$route.query.companyId}&${item}=${id}`)
          .then(response => {
            console.log('response', response);
            const myVendorList = [];
            if(item === 'projectId'){
              response.data.vendorList.forEach(val =>{
                myVendorList.push(val.companyVendor)
              })
            }else{
              response.data.vendorList.forEach(val =>{
                myVendorList.push(val.companyVendorPerson.companyVendor)
              })
            }
            this.taxList = response.data.projectTaxList;
            this.vendorList = myVendorList;
            resolve(response.data.vendorList)
          })
          .catch(error => {
            console.log('An error occurred:', error);
            reject(error)
          });
        })
      },
      getDirectoryProject(selectedRow){
        return new Promise((resolve, reject) =>{
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/projectTasks/directories?companyId=${this.$route.query.companyId}&projectId=${selectedRow.projectId}&operation=updateList`)
            .then(response => {
              let data = this.createMyList(response.data.projectVendorList, response.data.projectVendorPersonList);
              resolve(data)
            })
            .catch(error => {
              console.log('An error occurred:', error);
              reject(error)
            });
        })
      },
      createMyList(list, personList) {
        const myList = []

        for (let i = 0; i < list.length; i++) {
          myList.push({ ...list[i], people: [] })
          for (let j = 0; j < personList.length; j++) {
            if (list[i].companyVendorId === personList[j].companyVendorId) {
              myList[i].people.push(personList[j])
            }
          }
        }
        return myList
      },
      setItemToRequest(item){
              const addedItem = { id: item.id,
                                  code: item.number,
                                  name: item.name,
                                  amount:item.buyPrice || null,
                                  unit: item.unit,
                                  taxId: item.buyerProjectTax ? item.buyerProjectTax.id : null,
                                  itemWhTaxName: item.buyerWithholdingTax ? item.buyerWithholdingTax.name : null,
                                  qty: 1,
                                  date: '',

                                  //надо считать читает dom
                                  vatExclusive: '',
                                  total: '',

                                  tax:item.buyerProjectTax,
                                  wtx:item.buyerWithholdingTax}
          for (let i = 0; i < this.form.items.length; i++){
            if(this.form.items[i].id === item.id){
               this.form.items.splice(i, 1)
              return
            }
          }
        this.form.items.push(addedItem)
      },
      removeTag(id){
        for (let i = 0; i < this.form.items.length; i++){
          if(this.form.items[i].id === id){
            this.form.items.splice(i, 1)
            return
          }
        }      },
      //COUNT VAT EXCLUSIVE COLUMN
      countVatExclusive(amount, qty, tax, ifTax){
        console.log('amount, qty, tax, ifTax', amount, qty, tax, ifTax)
        //if no qty or amount
        if(!amount || amount === 0 || !qty && qty === 0){
          return 0
        }
        let percentages = ''
        switch(ifTax){
          case 'Tax Inclusive':
            //check if tax = 0
            if(!tax || tax.value === 0){
              return amount * qty
            }
            percentages = tax.value
            if(percentages.toString().length < 2){
              percentages = '1.0' + percentages.toString()
              console.log('1.0...', Number(percentages))
            }else{
              percentages = '1.' + percentages.toString()
              console.log('1.', Number(percentages))
            }
            return (amount * qty) / Number(percentages)
          case 'Tax Exclusive':
            return amount * qty
        }
        // if(ifTax === 'Tax Inclusive'){
        //   return amount / 2
        // }else{
        //   return amount * 2
        // }
      },
      //COUNT TOTAL AMOUNT EXCLUSIVE COLUMN
      countTotalAmount(amount, qty, tax, ifTax){
        //if no qty or amount
        if(!amount || amount === 0 || !qty && qty === 0){
          return 0
        }
        switch(ifTax){
          case 'Tax Inclusive':
            //check if tax = 0
            if(!tax || tax.value === 0){
              return amount * qty
            }else{
              return amount * qty
            }
          case 'Tax Exclusive':
            //check if tax = 0
            if(!tax || tax.value === 0) {
              return amount * qty
            }else{
              return (amount * qty) + (amount * qty) / 100 * tax.value
            }
        }
      },
      //COUNT SUBTOTAL
      countSubtotal(items){
        // console.log('subtotals', items)
        const results = []
        for (let i = 0; i < items.length; i++) {
            if(!items[i].amount || !items[i].qty || items[i].amount === 0 || items[i].qty === 0){
                results.push(0)
            }else{
              results.push(items[i].amount * items[i].qty)
            }
        }

        if (results.length === 0) {
          return 0
        }else{
          const result = results.reduce(function(sum, current) {
            return sum + current
          });

          // console.log('results', results)
          // console.log('result', result)
          return result
        }
      },
      //COUNT TAX OF
      countTaxOf(items){
         // console.log('taxofs', items)
        const results = []
        for (let i = 0; i < items.length; i++) {
            if(!items[i].vatExclusive || !items[i].tax || !items[i].tax === {}) {
              results.push(0)
            }else if (items[i].tax.value === 0) {
              results.push(0)
            }else {
              console.log('Number(items[i].vatExclusive)', Number(items[i].vatExclusive))
              results.push((Number(items[i].vatExclusive)/100)*Number(items[i].tax.value))
            }
        }

        if (results.length === 0) {
          return 0
        }else {
          const result = results.reduce(function (sum, current) {
            return sum + current
          });

          // console.log('results', results)
          // console.log('result', result)
          return result
        }

      },
      //COUNT SUM OF TOTAL AMOUNT
      countSumTotalAmount(items){
        const results = []
        for (let i = 0; i < items.length; i++) {
          results.push(items[i].total)
        }

        if (results.length === 0) {
          return 0
        }else {
          const result = results.reduce(function (sum, current) {
            return sum + current
          });

          // console.log('results', results)
          // console.log('result', result)
          return result
        }
      },
      //COUNT WHTAmount
      countWhtTaxAmount(items){
        // console.log('countWhtTaxAmount', items)
        const results = []

        for (let i = 0; i < items.length; i++) {
          if(!items[i].vatExclusive || !items[i].wtx || items[i].wtx === {} || items[i].wtx.value === 0){
            results.push(0)
          }else {
            results.push(items[i].vatExclusive / 100 * items[i].wtx.value)
          }
        }

        if (results.length === 0) {
          return 0
        }else {
          const result = results.reduce(function (sum, current) {
            return sum + current
          });

          // console.log('results', results)
          // console.log('result', result)
          return result
        }

      },
      //COUNT INCLUDES TAX OF
      countIncludesTaxOf(items){
        console.log('countIncludesTaxOf', items)
        const results = []

        for (let i = 0; i < items.length; i++) {
          if(!items[i].total || !items[i].total === 0 || !items[i].tax || items[i].tax.value === 0){
            results.push(0)
          }else{
            let percentages = ''
            percentages = items[i].tax.value
            if(percentages.toString().length < 2){
              percentages = '1.0' + percentages.toString()
              console.log('1.0...', Number(percentages))
            }else{
              percentages = '1.' + percentages.toString()
              console.log('1.', Number(percentages))
            }
            results.push(items[i].total - items[i].total / Number(percentages))
          }
        }

        if (results.length === 0) {
          return 0
        }else {
          const result = results.reduce(function (sum, current) {
            return sum + current
          });

          console.log('results', results)
          console.log('result', result)
          return result
        }

      },
      //COUNT PAYMENT TO VENDOR
      countPaymentToVendor(totalAmount, whtTaxAmount, ifWth){
        if(ifWth){
          return totalAmount - whtTaxAmount
        }else{
          return totalAmount
        }
      },
      checkNum(rule, value, callback){
        setTimeout(() => {
          if (value == 0) {
            return callback(new Error('Qty cant be 0'));
          }else{
            callback()
          }
        }, 500)
      },
      countModal(row, tax){
        row.tax = tax
        console.log('hello', row.tax)
      },
      countModalFull(){
        console.log('count full modal')
      },
      handleSelectVendor(vendor){
        this.disabledInputs = false
        if(this.selectedVendor.id !== vendor.id){
          this.form.items = []
          this.form.itemsId = []
        }
        this.selectedVendor = vendor
        this.itemsList = vendor.items
        console.log('vendor', vendor)
      },
      closePurchaseProjectTaskRequest(){
        // this.form.vendorId = ''
        // this.form.date = null
        // this.form.vendorCurrency = 'GBP'
        // this.form.vendorCredit = '0'
        // this.form.exchageRate = null
        // this.form.reference = null
        // this.form.deliverTo = null
        // this.form.ifTax = 'Tax Exclusive'
        // this.form.isWth = false
        // this.form.description = null
        // this.form.itemsId = []
        this.selectedProjectId = null
        this.projectList = []
        this.selectedTaskId = null
        this.projectTaskList = []
        this.form.items = []
        //bill
        this.form.subTotal = '0'
        this.form.taxOf = '0'
        this.form.totalAmount ='0'
        this.form.includesTaxOf = '0'
        this.form.whtTaxAmount = '0'
        this.form.paymentToVendor = '0'
        this.$refs['form'].resetFields();
        this.form.allowPartialDeliveries = false
        this.form.sendInventoryWithBill = false
        this.form.sendInventoryWithoutBill = false
        this.form.receiveReportRequired = false
        this.form.inspectionReportRequired = false
        this.disabledInputs = true
      },
      purchaseSubmit(form){
        this.$refs[form].validate((valid) => {
          if (valid) {
            if(this.form.items.length === 0) {
              return this.$message({
                type: 'error',
                message: 'Select items'
              })
            }

              const data = {
                vendorId: this.form.vendorId,
                orderDate: this.form.date / 1000,
                vendorCurrency: this.form.vendorCurrency,
                vendorCredit: this.form.vendorCredit,
                exchageRate: Number(this.form.exchageRate),
                reference: this.form.reference,
                deliverTo: this.form.deliverTo,
                includeTax: this.form.ifTax === 'Tax Exclusive',
                inludeWth: this.form.isWth,
                description: this.form.description,
                //bill
                subTotal: this.form.ifTax === 'Tax Exclusive' ? this.form.subTotal : null,
                taxOf: this.form.ifTax === 'Tax Exclusive' ? this.form.taxOf : null,
                totalAmount: this.form.totalAmount,
                includesTaxOf: this.form.ifTax === 'Tax Inclusive' ? this.form.includesTaxOf : null,
                whtTaxAmount: this.form.isWth ? this.form.whtTaxAmount : null,
                paymentToVendor: this.form.paymentToVendor,
                // checkboxes
                allowPartialDeliveries: this.form.allowPartialDeliveries,
                sendInventoryWithBill: this.form.sendInventoryWithBill,
                sendInventoryWithoutBill: this.form.sendInventoryWithoutBill,
                receiveReportRequired: this.form.receiveReportRequired,
                inspectionReportRequired: this.form.inspectionReportRequired,
            }

            const items = []
            this.form.items.forEach(val => {
                const item = {
                  originalItemId: val.id,
                  code: val.code,
                  name: val.name,
                  amount: val.amount,
                  unitId: val.unit.id,
                  taxId: val.taxId,
                  itemWhTaxId: val.wtx ? val.wtx.id : null,
                  qty: val.qty,
                  date: val.date / 1000,
                  vatExclusive: val.vatExclusive,
                  total: val.total,
                }
                items.push(item)
            })
            data.items = items
            return new Promise((resolve, reject) =>{
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
              axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
              axios
                .post(`/api/v1/purchaseRequest/create?type=project&companyId=${this.$route.query.companyId}&projectId=${this.selectedRow.projectId}&projectTaskId=${this.selectedRow.type === 'project' ? null : this.selectedRow.id}`, data)
                .then(response => {
                  this.notification("Success", "Request created", "success")
                  this.$refs.purchaseProjectTaskRequest.close()
                  if(this.$route.name === 'projects'){
                    this.$emit('refreshPurchase')
                  }
                  this.closePurchaseProjectTaskRequest()
                })
                .catch(error => {
                  console.log('An error occurred:', error);
                  reject(error)
                });
            })
          }
        })
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },
      cellClick(row, column, event){
        console.log('row', row)
        console.log('column', column)
      },
    }
  }
</script>

<style lang="less" scoped>
    /deep/.el-date-editor.el-input, .el-date-editor.el-input__inner {
        width:100%;
    }
    /deep/.sweet-modal-overlay{
        z-index:1000;
    .sweet-modal {
        max-width: 100% !important;
    }
    }
    .header-row{
        /deep/.el-input.is-disabled .el-input__inner{
            color: #404348;
        }
    }
    .bill{
        text-align:right;
        h4{
            line-height:0.6;
            span{
                padding: 0 10px;
            }
        }
        .payment-to-vendor{
            background: rgb(227, 228, 230);
            h3{
                span{
                    padding: 0 10px;
                }
            }
        }
    }
</style>
